// extracted by mini-css-extract-plugin
export default {"TextCard":"styles_TextCard__9gjr9","Cards":"styles_Cards__jD1Vr"};